import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EventTestimonials = ({ testimonials }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-6">
      <h2 className="text-2xl font-bold text-[var(--color-foreground)]">What Volunteers Say</h2>
      <div className="space-y-6">
        {testimonials?.map((testimonial) => (
          <div key={testimonial?.id} className="bg-[var(--color-muted)] rounded-lg p-6 space-y-4">
            <div className="flex items-center gap-1">
              {[...Array(5)]?.map((_, index) => (
                <Icon 
                  key={index}
                  name="Star" 
                  size={16} 
                  color={index < testimonial?.rating ? "var(--color-accent)" : "var(--color-border)"}
                  className={index < testimonial?.rating ? "fill-current" : ""}
                />
              ))}
            </div>

            <p className="text-[var(--color-foreground)] leading-relaxed italic">
              "{testimonial?.comment}"
            </p>

            <div className="flex items-center gap-3 pt-4 border-t border-[var(--color-border)]">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <Image 
                  src={testimonial?.avatar} 
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="font-semibold text-[var(--color-foreground)]">{testimonial?.name}</p>
                <p className="text-sm text-[var(--color-muted-foreground)]">{testimonial?.eventAttended}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventTestimonials;